import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ROUTE_RESET = 'PUT_ROUTE_RESET';
export const PUT_ROUTE_LOADING = 'PUT_ROUTE_LOADING';
export const PUT_ROUTE_SUCCESS = 'PUT_ROUTE_SUCCESS';
export const PUT_ROUTE_REJECT = 'PUT_ROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const putRouteReset = () => ({ type: PUT_ROUTE_RESET });
export const putRouteLoading = () => ({ type: PUT_ROUTE_LOADING });
export const putRouteSuccess = (payload) => ({ type: PUT_ROUTE_SUCCESS, payload });
export const putRouteReject = (payload) => ({ type: PUT_ROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putRouteRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Route/web/UpdateRoute`, options);
};


